import styled from "styled-components/native";
import { Svg } from "react-native-svg";
import { space } from "../../theming/styledSystem";

export const StyledSvg = styled(Svg)`
  border-radius: 2px;
  ${space}
`;
